import { deepSetObject, digObject, toggleArray } from '@domain-group/javascript-utils'

import { Box, ListItem, ToggleButton } from '@domain-group/suit-theme'

import { useSystemForm } from '@hooks/useSystem'

type IntegrationPlatform = { key: string, title: string}

type HandleToggleIntegrationPlatformParams = {
  broadcastIntegrations: string[],
  integrationPlatform: IntegrationPlatform,
  systemForm: ReturnType<typeof useSystemForm>,
}

const handleToggleIntegrationPlatform = (params: HandleToggleIntegrationPlatformParams) => {
  const { broadcastIntegrations, integrationPlatform, systemForm } = params
  const {
    entityState: {
      options,
    },
    setEntityState,
  } = systemForm

  const updatedBroadcastIntegrations = toggleArray(broadcastIntegrations, integrationPlatform.key)
  // @ts-expect-error TS2345
  const updatedOptions = deepSetObject(options, 'broadcast_integrations', updatedBroadcastIntegrations)

  setEntityState({ options: updatedOptions })
}

interface IntegrationPlatformListItemProps {
  integrationPlatform: IntegrationPlatform,
  systemForm: ReturnType<typeof useSystemForm>,
}

const IntegrationPlatformListItem = (props: IntegrationPlatformListItemProps) => {
  const { integrationPlatform, systemForm } = props
  const { entityState } = systemForm

  const broadcastIntegrations = digObject(entityState, 'options.broadcast_integrations', [])
  const shouldBroadcastIntegration = broadcastIntegrations.includes(integrationPlatform.key)

  return (
    <ListItem
      boxProps={{
        borderBottom: '1px dashed',
        fontSize: 'small',
        lineHeight: 1.3,
      }}
      disableHover
    >
      <Box flexDirection="column">
        <Box alignItems="center" justifyContent="space-between" marginY="medium">
          <Box flexDirection="column" maxWidth="80%">
            {integrationPlatform.title}
          </Box>

          <ToggleButton
            onClick={() => handleToggleIntegrationPlatform({ broadcastIntegrations, integrationPlatform, systemForm })}
            toggleOffText="Off"
            toggleOn={shouldBroadcastIntegration}
            toggleOnText="On"
          />
        </Box>
      </Box>
    </ListItem>
  )
}

export default IntegrationPlatformListItem
